import { render, staticRenderFns } from "./ChannelSettings.vue?vue&type=template&id=4a67b934&scoped=true&"
import script from "./ChannelSettings.vue?vue&type=script&lang=ts&"
export * from "./ChannelSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelSettings.vue?vue&type=style&index=0&id=4a67b934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a67b934",
  null
  
)

export default component.exports